<!-- Tüm şubelerin para birimi bazında bakiyesi. app-kpi-card temaya göre çizilir
     (modern: .m-kpi, klasik: Skote mini-stats-wid). Ana değer toplam bakiye; kasa ve
     müşteri bakiyesi ek değer olarak (müşteri bakiyesi artı yeşil, eksi kırmızı). -->
<div class="row row-cols-1 row-cols-sm-2 row-cols-lg-4 row-cols-xxl-5 g-3 mb-3"
     *ngIf="hasUserRole && authorizedBranches.length > 1">

  <ng-container *ngIf="loading">
    <div class="col" *ngFor="let placeholder of loadingPlaceholders">
      <app-kpi-card label="Yükleniyor" value="" [loading]="true"></app-kpi-card>
    </div>
  </ng-container>

  <div class="col-12 w-100" *ngIf="!loading && !cards.length">
    <div class="card mini-stats-wid mb-0">
      <div class="card-body text-muted small">Gösterilecek bakiye bulunamadı.</div>
    </div>
  </div>

  <ng-container *ngIf="!loading">
    <div class="col" *ngFor="let card of cards">
      <app-kpi-card [label]="card.label" [value]="card.value" [icon]="card.icon" [tone]="card.tone"
                    [extras]="card.extras" comparison="Toplam bakiye">
      </app-kpi-card>
    </div>
  </ng-container>
</div>
